export const LlaveEnMano = [
  {
    index: "01",
    title: "Desarrollo de ingeniería.",
    desc: "Dimensionamiento y Selección de equipos, Memorias de cálculo, isométricos, DTI’s, cálculo y diseño de líneas de combustible, vapor, condensados, ingeniería de reversa, entre otros.",
  },
  {
    index: "02",
    title: "Venta de calderas y equipos auxiliares.",
    desc: "Ofrecemos soluciones en calderas de vapor y agua caliente de cualquier capacidad, combustible, presión de diseño, todo tipo de marcas, tanto nacionales, americanas o europeas. También proveemos los equipos periféricos e infraestructura que acompañan a una caldera, es por ello que nuestros servicios y alcances siempre estarán orientados a la eficiencia y optimización del cuarto de calderas.",
  },
  {
    index: "03",
    title: "Instalación electromecánica.",
    desc: "Realizamos la instalación de todas las líneas de suministro: combustible, vapor, agua, etc. Requeridas por la caldera y equipos auxiliares, siempre de acuerdo con las normas de instalación y de recipientes sujetos a presión NOM-020-STPS, API’s, entre otras.",
  },
  {
    index: "04",
    title: "Puesta en marcha.",
    desc: "Realizamos la configuración de su caldera y auxiliares para que opere de forma eficiente y segura.",
  },
];
export const MantenimientoU = [
  {
    index: "01",
    title: "Preventivo.",
    desc: "Realizamos diagnósticos del estado de su equipo para prevenir fallas que generen tiempos muertos, se generan reportes con sugerencias de mejora y prevención de fallas.",
  },
  {
    index: "02",
    title: "Correctivo.",
    desc: "Corregimos cualquier falla y en conjunto con su personal analizamos las causas, posteriormente asesoramos a su personal para que no vuelva a presentarse.",
  },
  {
    index: "03",
    title: "Pólizas de mantenimiento.",
    desc: "Diseñamos una póliza de mantenimiento acorde a tus requerimientos, que permitan mantener tus equipos trabajando en todo momento en condiciones óptimas de eficiencia y seguridad.",
  },
  {
    index: "04",
    title: "Reconstrucción de calderas.",
    desc: "Realizamos un análisis a tus calderas y auxiliares y ejecutamos de manera rápida la reconstrucción que se requiera y permita prolongar la vida útil de tus equipos, aplicando todos los procedimientos de acuerdo con las normas aplicables y con el personal mejor capacitado y con gran experiencia en el ramo.",
  },
];

export const ServiciosAdicionalesU = [
  {
    index: "01",
    title: "Ahorro de energía.",
    desc: "Realizamos auditorias, análisis y proponemos ahorros de energía comprobables para su planta por medio de nuestro equipo de especialistas en el ramo energético.",
  },
  {
    index: "02",
    title: "Renta de calderas.",
    desc: "Contamos con un extenso stock de equipos, en las mejores condiciones y disponibles para ajustarnos a sus requerimientos.",
  },
  {
    index: "03",
    title: "Venta de refacciones originales y genéricas",
    desc: "Mantenemos un amplio stock de refacciones originales y genéricas con el cual cubriremos su necesidad en tiempos cortos.",
  },
  {
    index: "04",
    title: "Retrofits: Actualizaciones de calderas",
    desc: "Nuestro equipo de especialistas le ofrecerá las soluciones tecnológicas que más se ajusten a sus requerimientos técnicos y económicos, por medio de las cuales incremente la eficiencia y prolongue la vida útil de sus equipos.",
  },
];
export const CapacitacionU = [
  {
    index: "01",
    title: "Operadores de calderas.",
    desc: "Diseñados para operadores, supervisores o gerentes de mantenimiento y cualquier persona que tenga interacción con calderas o desee ampliar su conocimiento de estos equipos, apegándose a la normatividad vigente NOM-020, NOM-026 y NOM-085 STPS, entre otras",
  },
  {
    index: "02",
    title: "Plantas de emergencia.",
    desc: "Diseñados para operadores, supervisores o gerentes de mantenimiento que tengan relación con las plantas de emergencia y requieran adquirir conocimientos de operación, mantenimiento y seguridad de estos equipos.",
  },
];
